export default __webpack_public_path__ + "static/media/escuchanos1.452734bf.png";